import {UserScheduleActions, UserScheduleState} from "./types";

export const initialUserScheduleState: UserScheduleState = {
  isCreateUserScheduleModalOpen: false,
};

export const userScheduleReducer = (
  state: UserScheduleState = initialUserScheduleState,
  action: UserScheduleActions
): UserScheduleState => {
  if (action.type === "toggle-create-user-schedule-modal") {
    const yo: UserScheduleState = {
      ...state,
      isCreateUserScheduleModalOpen: action.payload,
    };
    return yo;
  }
  if (action.type === "reset-state") {
    const yo = {...initialUserScheduleState};
    return yo;
  }

  return state;
};
